export default {
  language: (state) => state.app.language,
  userInfo: (state) => state.user.userInfo,
}
